export * from 'components/Phantom/_shop/Modals/Modal/Modal'
